/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  AudienceSelectionDto,
  CommunicationDecisionDto,
  CreateCommunicationDto,
  DataEnvelopeOfAttachmentDownloadDto,
  DataEnvelopeOfAudienceCountDto,
  DataEnvelopeOfAudiencePreviewDto,
  DataEnvelopeOfCommunicationDto,
  DataEnvelopeOfIReadOnlyListOfCommunicationRecipientDto,
  DataEnvelopeOfIReadOnlyListOfPendingAcknowledgementDto,
  DataEnvelopeOfObject,
  DataPaginationEnvelopeOfAudienceUserDto,
  DataPaginationEnvelopeOfCommunicationDto,
  ErrorEnvelope,
  GetAllCommunicationsParams,
  GetAudienceUsersParams,
  GetEditorialCommunicationsParams,
  GetNoticeBoardParams,
  ScheduleCommunicationDto,
  UpdateCommunicationDto,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

/**
 * @summary Lista todos os comunicados com filtros
 */
export const getAllCommunications = (
  params?: GetAllCommunicationsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataPaginationEnvelopeOfCommunicationDto>(
    { url: `/v1/communications`, method: 'GET', params, signal },
    options,
  )
}

export const getGetAllCommunicationsQueryKey = (params?: GetAllCommunicationsParams) => {
  return [`/v1/communications`, ...(params ? [params] : [])] as const
}

export const getGetAllCommunicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllCommunications>>,
  TError = unknown,
>(
  params?: GetAllCommunicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllCommunications>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAllCommunicationsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCommunications>>> = ({ signal }) =>
    getAllCommunications(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllCommunications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAllCommunicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllCommunications>>
>
export type GetAllCommunicationsQueryError = unknown

export function useGetAllCommunications<
  TData = Awaited<ReturnType<typeof getAllCommunications>>,
  TError = unknown,
>(
  params: undefined | GetAllCommunicationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllCommunications>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCommunications>>,
          TError,
          Awaited<ReturnType<typeof getAllCommunications>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllCommunications<
  TData = Awaited<ReturnType<typeof getAllCommunications>>,
  TError = unknown,
>(
  params?: GetAllCommunicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllCommunications>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCommunications>>,
          TError,
          Awaited<ReturnType<typeof getAllCommunications>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAllCommunications<
  TData = Awaited<ReturnType<typeof getAllCommunications>>,
  TError = unknown,
>(
  params?: GetAllCommunicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllCommunications>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista todos os comunicados com filtros
 */

export function useGetAllCommunications<
  TData = Awaited<ReturnType<typeof getAllCommunications>>,
  TError = unknown,
>(
  params?: GetAllCommunicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAllCommunications>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllCommunicationsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Cria novo comunicado (MANAGER/ADMIN)
 */
export const createCommunication = (
  createCommunicationDto: CreateCommunicationDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationDto>(
    {
      url: `/v1/communications`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCommunicationDto,
      signal,
    },
    options,
  )
}

export const getCreateCommunicationMutationKey = () => ['createCommunication'] as const

export const getCreateCommunicationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCommunication>>,
    TError,
    CreateCommunicationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCommunication>>,
  TError,
  CreateCommunicationMutationVariables,
  TContext
> => {
  const mutationKey = getCreateCommunicationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCommunication>>,
    CreateCommunicationMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return createCommunication(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateCommunicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCommunication>>
>
export type CreateCommunicationMutationBody = CreateCommunicationDto
export type CreateCommunicationMutationError = unknown
export type CreateCommunicationMutationVariables = { data: CreateCommunicationDto }

/**
 * @summary Cria novo comunicado (MANAGER/ADMIN)
 */
export const useCreateCommunication = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCommunication>>,
      TError,
      CreateCommunicationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCommunication>>,
  TError,
  CreateCommunicationMutationVariables,
  TContext
> => {
  return useMutation(getCreateCommunicationMutationOptions(options), queryClient)
}
/**
 * @summary Mural pessoal: somente a audiência publicada do usuário autenticado
 */
export const getNoticeBoard = (
  params?: GetNoticeBoardParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataPaginationEnvelopeOfCommunicationDto>(
    { url: `/v1/communications/board`, method: 'GET', params, signal },
    options,
  )
}

export const getGetNoticeBoardQueryKey = (params?: GetNoticeBoardParams) => {
  return [`/v1/communications/board`, ...(params ? [params] : [])] as const
}

export const getGetNoticeBoardQueryOptions = <
  TData = Awaited<ReturnType<typeof getNoticeBoard>>,
  TError = unknown,
>(
  params?: GetNoticeBoardParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNoticeBoard>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNoticeBoardQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNoticeBoard>>> = ({ signal }) =>
    getNoticeBoard(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNoticeBoard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNoticeBoardQueryResult = NonNullable<Awaited<ReturnType<typeof getNoticeBoard>>>
export type GetNoticeBoardQueryError = unknown

export function useGetNoticeBoard<
  TData = Awaited<ReturnType<typeof getNoticeBoard>>,
  TError = unknown,
>(
  params: undefined | GetNoticeBoardParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNoticeBoard>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNoticeBoard>>,
          TError,
          Awaited<ReturnType<typeof getNoticeBoard>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNoticeBoard<
  TData = Awaited<ReturnType<typeof getNoticeBoard>>,
  TError = unknown,
>(
  params?: GetNoticeBoardParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNoticeBoard>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNoticeBoard>>,
          TError,
          Awaited<ReturnType<typeof getNoticeBoard>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNoticeBoard<
  TData = Awaited<ReturnType<typeof getNoticeBoard>>,
  TError = unknown,
>(
  params?: GetNoticeBoardParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNoticeBoard>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Mural pessoal: somente a audiência publicada do usuário autenticado
 */

export function useGetNoticeBoard<
  TData = Awaited<ReturnType<typeof getNoticeBoard>>,
  TError = unknown,
>(
  params?: GetNoticeBoardParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNoticeBoard>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNoticeBoardQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Lista ciências pendentes do usuário autenticado
 */
export const getPendingAcknowledgements = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfIReadOnlyListOfPendingAcknowledgementDto>(
    { url: `/v1/communications/acknowledgements/pending`, method: 'GET', signal },
    options,
  )
}

export const getGetPendingAcknowledgementsQueryKey = () => {
  return [`/v1/communications/acknowledgements/pending`] as const
}

export const getGetPendingAcknowledgementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPendingAcknowledgements>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getPendingAcknowledgements>>, TError, TData>
  >
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPendingAcknowledgementsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingAcknowledgements>>> = ({
    signal,
  }) => getPendingAcknowledgements(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPendingAcknowledgements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPendingAcknowledgementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPendingAcknowledgements>>
>
export type GetPendingAcknowledgementsQueryError = unknown

export function useGetPendingAcknowledgements<
  TData = Awaited<ReturnType<typeof getPendingAcknowledgements>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPendingAcknowledgements>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingAcknowledgements>>,
          TError,
          Awaited<ReturnType<typeof getPendingAcknowledgements>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingAcknowledgements<
  TData = Awaited<ReturnType<typeof getPendingAcknowledgements>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPendingAcknowledgements>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingAcknowledgements>>,
          TError,
          Awaited<ReturnType<typeof getPendingAcknowledgements>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingAcknowledgements<
  TData = Awaited<ReturnType<typeof getPendingAcknowledgements>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPendingAcknowledgements>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista ciências pendentes do usuário autenticado
 */

export function useGetPendingAcknowledgements<
  TData = Awaited<ReturnType<typeof getPendingAcknowledgements>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPendingAcknowledgements>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPendingAcknowledgementsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Obtém comunicado por ID
 */
export const getCommunicationById = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationDto>(
    { url: `/v1/communications/${id}`, method: 'GET', signal },
    options,
  )
}

export const getGetCommunicationByIdQueryKey = (id: string) => {
  return [`/v1/communications/${id}`] as const
}

export const getGetCommunicationByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommunicationById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationById>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCommunicationByIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommunicationById>>> = ({ signal }) =>
    getCommunicationById(id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCommunicationById>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetCommunicationByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommunicationById>>
>
export type GetCommunicationByIdQueryError = unknown

export function useGetCommunicationById<
  TData = Awaited<ReturnType<typeof getCommunicationById>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationById>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationById>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationById<
  TData = Awaited<ReturnType<typeof getCommunicationById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationById>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationById>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationById<
  TData = Awaited<ReturnType<typeof getCommunicationById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationById>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Obtém comunicado por ID
 */

export function useGetCommunicationById<
  TData = Awaited<ReturnType<typeof getCommunicationById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationById>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCommunicationByIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Atualiza comunicado (MANAGER/ADMIN)
 */
export const updateCommunication = (
  id: string,
  updateCommunicationDto: UpdateCommunicationDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationDto>(
    {
      url: `/v1/communications/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateCommunicationDto,
      signal,
    },
    options,
  )
}

export const getUpdateCommunicationMutationKey = () => ['updateCommunication'] as const

export const getUpdateCommunicationMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommunication>>,
    TError,
    UpdateCommunicationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCommunication>>,
  TError,
  UpdateCommunicationMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateCommunicationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCommunication>>,
    UpdateCommunicationMutationVariables
  > = (props) => {
    const { id, data } = props ?? {}

    return updateCommunication(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateCommunicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCommunication>>
>
export type UpdateCommunicationMutationBody = UpdateCommunicationDto
export type UpdateCommunicationMutationError = ErrorEnvelope
export type UpdateCommunicationMutationVariables = { id: string; data: UpdateCommunicationDto }

/**
 * @summary Atualiza comunicado (MANAGER/ADMIN)
 */
export const useUpdateCommunication = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCommunication>>,
      TError,
      UpdateCommunicationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCommunication>>,
  TError,
  UpdateCommunicationMutationVariables,
  TContext
> => {
  return useMutation(getUpdateCommunicationMutationOptions(options), queryClient)
}
/**
 * @summary Remove comunicado (ADMIN)
 */
export const deleteCommunication = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/communications/${id}`, method: 'DELETE', signal },
    options,
  )
}

export const getDeleteCommunicationMutationKey = () => ['deleteCommunication'] as const

export const getDeleteCommunicationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCommunication>>,
    TError,
    DeleteCommunicationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCommunication>>,
  TError,
  DeleteCommunicationMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteCommunicationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCommunication>>,
    DeleteCommunicationMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return deleteCommunication(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCommunicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCommunication>>
>

export type DeleteCommunicationMutationError = unknown
export type DeleteCommunicationMutationVariables = { id: string }

/**
 * @summary Remove comunicado (ADMIN)
 */
export const useDeleteCommunication = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCommunication>>,
      TError,
      DeleteCommunicationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCommunication>>,
  TError,
  DeleteCommunicationMutationVariables,
  TContext
> => {
  return useMutation(getDeleteCommunicationMutationOptions(options), queryClient)
}
/**
 * @summary Publica comunicado (MANAGER/ADMIN)
 */
export const publishCommunication = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationDto>(
    { url: `/v1/communications/${id}/publish`, method: 'POST', signal },
    options,
  )
}

export const getPublishCommunicationMutationKey = () => ['publishCommunication'] as const

export const getPublishCommunicationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishCommunication>>,
    TError,
    PublishCommunicationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof publishCommunication>>,
  TError,
  PublishCommunicationMutationVariables,
  TContext
> => {
  const mutationKey = getPublishCommunicationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publishCommunication>>,
    PublishCommunicationMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return publishCommunication(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PublishCommunicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof publishCommunication>>
>

export type PublishCommunicationMutationError = unknown
export type PublishCommunicationMutationVariables = { id: string }

/**
 * @summary Publica comunicado (MANAGER/ADMIN)
 */
export const usePublishCommunication = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof publishCommunication>>,
      TError,
      PublishCommunicationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof publishCommunication>>,
  TError,
  PublishCommunicationMutationVariables,
  TContext
> => {
  return useMutation(getPublishCommunicationMutationOptions(options), queryClient)
}
/**
 * @summary Despublica comunicado (MANAGER/ADMIN)
 */
export const unpublishCommunication = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationDto>(
    { url: `/v1/communications/${id}/unpublish`, method: 'POST', signal },
    options,
  )
}

export const getUnpublishCommunicationMutationKey = () => ['unpublishCommunication'] as const

export const getUnpublishCommunicationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unpublishCommunication>>,
    TError,
    UnpublishCommunicationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof unpublishCommunication>>,
  TError,
  UnpublishCommunicationMutationVariables,
  TContext
> => {
  const mutationKey = getUnpublishCommunicationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unpublishCommunication>>,
    UnpublishCommunicationMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return unpublishCommunication(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UnpublishCommunicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof unpublishCommunication>>
>

export type UnpublishCommunicationMutationError = unknown
export type UnpublishCommunicationMutationVariables = { id: string }

/**
 * @summary Despublica comunicado (MANAGER/ADMIN)
 */
export const useUnpublishCommunication = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unpublishCommunication>>,
      TError,
      UnpublishCommunicationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof unpublishCommunication>>,
  TError,
  UnpublishCommunicationMutationVariables,
  TContext
> => {
  return useMutation(getUnpublishCommunicationMutationOptions(options), queryClient)
}
/**
 * @summary Agenda comunicado para publicação futura (MANAGER/ADMIN)
 */
export const scheduleCommunication = (
  id: string,
  scheduleCommunicationDto: ScheduleCommunicationDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationDto>(
    {
      url: `/v1/communications/${id}/schedule`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: scheduleCommunicationDto,
      signal,
    },
    options,
  )
}

export const getScheduleCommunicationMutationKey = () => ['scheduleCommunication'] as const

export const getScheduleCommunicationMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleCommunication>>,
    TError,
    ScheduleCommunicationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduleCommunication>>,
  TError,
  ScheduleCommunicationMutationVariables,
  TContext
> => {
  const mutationKey = getScheduleCommunicationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduleCommunication>>,
    ScheduleCommunicationMutationVariables
  > = (props) => {
    const { id, data } = props ?? {}

    return scheduleCommunication(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ScheduleCommunicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof scheduleCommunication>>
>
export type ScheduleCommunicationMutationBody = ScheduleCommunicationDto
export type ScheduleCommunicationMutationError = ErrorEnvelope
export type ScheduleCommunicationMutationVariables = { id: string; data: ScheduleCommunicationDto }

/**
 * @summary Agenda comunicado para publicação futura (MANAGER/ADMIN)
 */
export const useScheduleCommunication = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof scheduleCommunication>>,
      TError,
      ScheduleCommunicationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof scheduleCommunication>>,
  TError,
  ScheduleCommunicationMutationVariables,
  TContext
> => {
  return useMutation(getScheduleCommunicationMutationOptions(options), queryClient)
}
/**
 * @summary Remove agendamento de comunicado (MANAGER/ADMIN)
 */
export const unscheduleCommunication = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationDto>(
    { url: `/v1/communications/${id}/unschedule`, method: 'POST', signal },
    options,
  )
}

export const getUnscheduleCommunicationMutationKey = () => ['unscheduleCommunication'] as const

export const getUnscheduleCommunicationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unscheduleCommunication>>,
    TError,
    UnscheduleCommunicationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof unscheduleCommunication>>,
  TError,
  UnscheduleCommunicationMutationVariables,
  TContext
> => {
  const mutationKey = getUnscheduleCommunicationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unscheduleCommunication>>,
    UnscheduleCommunicationMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return unscheduleCommunication(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UnscheduleCommunicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof unscheduleCommunication>>
>

export type UnscheduleCommunicationMutationError = unknown
export type UnscheduleCommunicationMutationVariables = { id: string }

/**
 * @summary Remove agendamento de comunicado (MANAGER/ADMIN)
 */
export const useUnscheduleCommunication = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unscheduleCommunication>>,
      TError,
      UnscheduleCommunicationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof unscheduleCommunication>>,
  TError,
  UnscheduleCommunicationMutationVariables,
  TContext
> => {
  return useMutation(getUnscheduleCommunicationMutationOptions(options), queryClient)
}
/**
 * @summary Marca comunicado como lido
 */
export const markCommunicationAsRead = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/v1/communications/${id}/read`, method: 'POST', signal },
    options,
  )
}

export const getMarkCommunicationAsReadMutationKey = () => ['markCommunicationAsRead'] as const

export const getMarkCommunicationAsReadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markCommunicationAsRead>>,
    TError,
    MarkCommunicationAsReadMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof markCommunicationAsRead>>,
  TError,
  MarkCommunicationAsReadMutationVariables,
  TContext
> => {
  const mutationKey = getMarkCommunicationAsReadMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markCommunicationAsRead>>,
    MarkCommunicationAsReadMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return markCommunicationAsRead(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type MarkCommunicationAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markCommunicationAsRead>>
>

export type MarkCommunicationAsReadMutationError = unknown
export type MarkCommunicationAsReadMutationVariables = { id: string }

/**
 * @summary Marca comunicado como lido
 */
export const useMarkCommunicationAsRead = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markCommunicationAsRead>>,
      TError,
      MarkCommunicationAsReadMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markCommunicationAsRead>>,
  TError,
  MarkCommunicationAsReadMutationVariables,
  TContext
> => {
  return useMutation(getMarkCommunicationAsReadMutationOptions(options), queryClient)
}
/**
 * @summary Registra ciência do destinatário em comunicado obrigatório
 */
export const acknowledgeCommunication = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/communications/${id}/acknowledge`, method: 'POST', signal },
    options,
  )
}

export const getAcknowledgeCommunicationMutationKey = () => ['acknowledgeCommunication'] as const

export const getAcknowledgeCommunicationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acknowledgeCommunication>>,
    TError,
    AcknowledgeCommunicationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof acknowledgeCommunication>>,
  TError,
  AcknowledgeCommunicationMutationVariables,
  TContext
> => {
  const mutationKey = getAcknowledgeCommunicationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acknowledgeCommunication>>,
    AcknowledgeCommunicationMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return acknowledgeCommunication(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type AcknowledgeCommunicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof acknowledgeCommunication>>
>

export type AcknowledgeCommunicationMutationError = unknown
export type AcknowledgeCommunicationMutationVariables = { id: string }

/**
 * @summary Registra ciência do destinatário em comunicado obrigatório
 */
export const useAcknowledgeCommunication = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acknowledgeCommunication>>,
      TError,
      AcknowledgeCommunicationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof acknowledgeCommunication>>,
  TError,
  AcknowledgeCommunicationMutationVariables,
  TContext
> => {
  return useMutation(getAcknowledgeCommunicationMutationOptions(options), queryClient)
}
export const submitCommunicationForReview = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationDto>(
    { url: `/v1/communications/${id}/submit-review`, method: 'POST', signal },
    options,
  )
}

export const getSubmitCommunicationForReviewMutationKey = () =>
  ['submitCommunicationForReview'] as const

export const getSubmitCommunicationForReviewMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitCommunicationForReview>>,
    TError,
    SubmitCommunicationForReviewMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitCommunicationForReview>>,
  TError,
  SubmitCommunicationForReviewMutationVariables,
  TContext
> => {
  const mutationKey = getSubmitCommunicationForReviewMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitCommunicationForReview>>,
    SubmitCommunicationForReviewMutationVariables
  > = (props) => {
    const { id } = props ?? {}

    return submitCommunicationForReview(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type SubmitCommunicationForReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitCommunicationForReview>>
>

export type SubmitCommunicationForReviewMutationError = unknown
export type SubmitCommunicationForReviewMutationVariables = { id: string }

export const useSubmitCommunicationForReview = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitCommunicationForReview>>,
      TError,
      SubmitCommunicationForReviewMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitCommunicationForReview>>,
  TError,
  SubmitCommunicationForReviewMutationVariables,
  TContext
> => {
  return useMutation(getSubmitCommunicationForReviewMutationOptions(options), queryClient)
}
export const approveCommunication = (
  id: string,
  communicationDecisionDto: CommunicationDecisionDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationDto>(
    {
      url: `/v1/communications/${id}/approve`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: communicationDecisionDto,
      signal,
    },
    options,
  )
}

export const getApproveCommunicationMutationKey = () => ['approveCommunication'] as const

export const getApproveCommunicationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveCommunication>>,
    TError,
    ApproveCommunicationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveCommunication>>,
  TError,
  ApproveCommunicationMutationVariables,
  TContext
> => {
  const mutationKey = getApproveCommunicationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveCommunication>>,
    ApproveCommunicationMutationVariables
  > = (props) => {
    const { id, data } = props ?? {}

    return approveCommunication(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ApproveCommunicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveCommunication>>
>
export type ApproveCommunicationMutationBody = CommunicationDecisionDto
export type ApproveCommunicationMutationError = unknown
export type ApproveCommunicationMutationVariables = { id: string; data: CommunicationDecisionDto }

export const useApproveCommunication = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveCommunication>>,
      TError,
      ApproveCommunicationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof approveCommunication>>,
  TError,
  ApproveCommunicationMutationVariables,
  TContext
> => {
  return useMutation(getApproveCommunicationMutationOptions(options), queryClient)
}
export const rejectCommunication = (
  id: string,
  communicationDecisionDto: CommunicationDecisionDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfCommunicationDto>(
    {
      url: `/v1/communications/${id}/reject`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: communicationDecisionDto,
      signal,
    },
    options,
  )
}

export const getRejectCommunicationMutationKey = () => ['rejectCommunication'] as const

export const getRejectCommunicationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectCommunication>>,
    TError,
    RejectCommunicationMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectCommunication>>,
  TError,
  RejectCommunicationMutationVariables,
  TContext
> => {
  const mutationKey = getRejectCommunicationMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectCommunication>>,
    RejectCommunicationMutationVariables
  > = (props) => {
    const { id, data } = props ?? {}

    return rejectCommunication(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type RejectCommunicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectCommunication>>
>
export type RejectCommunicationMutationBody = CommunicationDecisionDto
export type RejectCommunicationMutationError = unknown
export type RejectCommunicationMutationVariables = { id: string; data: CommunicationDecisionDto }

export const useRejectCommunication = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rejectCommunication>>,
      TError,
      RejectCommunicationMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rejectCommunication>>,
  TError,
  RejectCommunicationMutationVariables,
  TContext
> => {
  return useMutation(getRejectCommunicationMutationOptions(options), queryClient)
}
export const getCommunicationRecipients = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfIReadOnlyListOfCommunicationRecipientDto>(
    { url: `/v1/communications/${id}/recipients`, method: 'GET', signal },
    options,
  )
}

export const getGetCommunicationRecipientsQueryKey = (id: string) => {
  return [`/v1/communications/${id}/recipients`] as const
}

export const getGetCommunicationRecipientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommunicationRecipients>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationRecipients>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCommunicationRecipientsQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommunicationRecipients>>> = ({
    signal,
  }) => getCommunicationRecipients(id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCommunicationRecipients>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetCommunicationRecipientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommunicationRecipients>>
>
export type GetCommunicationRecipientsQueryError = unknown

export function useGetCommunicationRecipients<
  TData = Awaited<ReturnType<typeof getCommunicationRecipients>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationRecipients>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationRecipients>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationRecipients>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationRecipients<
  TData = Awaited<ReturnType<typeof getCommunicationRecipients>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationRecipients>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationRecipients>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationRecipients>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationRecipients<
  TData = Awaited<ReturnType<typeof getCommunicationRecipients>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationRecipients>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCommunicationRecipients<
  TData = Awaited<ReturnType<typeof getCommunicationRecipients>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationRecipients>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCommunicationRecipientsQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const exportCommunicationRecipients = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/v1/communications/${id}/recipients/export`, method: 'GET', signal },
    options,
  )
}

export const getExportCommunicationRecipientsQueryKey = (id: string) => {
  return [`/v1/communications/${id}/recipients/export`] as const
}

export const getExportCommunicationRecipientsQueryOptions = <
  TData = Awaited<ReturnType<typeof exportCommunicationRecipients>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportCommunicationRecipients>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getExportCommunicationRecipientsQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportCommunicationRecipients>>> = ({
    signal,
  }) => exportCommunicationRecipients(id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof exportCommunicationRecipients>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type ExportCommunicationRecipientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportCommunicationRecipients>>
>
export type ExportCommunicationRecipientsQueryError = unknown

export function useExportCommunicationRecipients<
  TData = Awaited<ReturnType<typeof exportCommunicationRecipients>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportCommunicationRecipients>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCommunicationRecipients>>,
          TError,
          Awaited<ReturnType<typeof exportCommunicationRecipients>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportCommunicationRecipients<
  TData = Awaited<ReturnType<typeof exportCommunicationRecipients>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportCommunicationRecipients>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCommunicationRecipients>>,
          TError,
          Awaited<ReturnType<typeof exportCommunicationRecipients>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportCommunicationRecipients<
  TData = Awaited<ReturnType<typeof exportCommunicationRecipients>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportCommunicationRecipients>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportCommunicationRecipients<
  TData = Awaited<ReturnType<typeof exportCommunicationRecipients>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof exportCommunicationRecipients>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getExportCommunicationRecipientsQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Emite URL GET curta após validar tenant, comunicado e audiência
 */
export const downloadCommunicationAttachment = (
  id: string,
  attachmentId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfAttachmentDownloadDto>(
    { url: `/v1/communications/${id}/attachments/${attachmentId}/download`, method: 'GET', signal },
    options,
  )
}

export const getDownloadCommunicationAttachmentQueryKey = (id: string, attachmentId: string) => {
  return [`/v1/communications/${id}/attachments/${attachmentId}/download`] as const
}

export const getDownloadCommunicationAttachmentQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadCommunicationAttachment>>,
  TError = unknown,
>(
  id: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadCommunicationAttachment>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getDownloadCommunicationAttachmentQueryKey(id, attachmentId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadCommunicationAttachment>>> = ({
    signal,
  }) => downloadCommunicationAttachment(id, attachmentId, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined && attachmentId !== null && attachmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadCommunicationAttachment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadCommunicationAttachmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadCommunicationAttachment>>
>
export type DownloadCommunicationAttachmentQueryError = unknown

export function useDownloadCommunicationAttachment<
  TData = Awaited<ReturnType<typeof downloadCommunicationAttachment>>,
  TError = unknown,
>(
  id: string,
  attachmentId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadCommunicationAttachment>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadCommunicationAttachment>>,
          TError,
          Awaited<ReturnType<typeof downloadCommunicationAttachment>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadCommunicationAttachment<
  TData = Awaited<ReturnType<typeof downloadCommunicationAttachment>>,
  TError = unknown,
>(
  id: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadCommunicationAttachment>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadCommunicationAttachment>>,
          TError,
          Awaited<ReturnType<typeof downloadCommunicationAttachment>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadCommunicationAttachment<
  TData = Awaited<ReturnType<typeof downloadCommunicationAttachment>>,
  TError = unknown,
>(
  id: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadCommunicationAttachment>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Emite URL GET curta após validar tenant, comunicado e audiência
 */

export function useDownloadCommunicationAttachment<
  TData = Awaited<ReturnType<typeof downloadCommunicationAttachment>>,
  TError = unknown,
>(
  id: string,
  attachmentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadCommunicationAttachment>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDownloadCommunicationAttachmentQueryOptions(id, attachmentId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getCommunicationAudiencePreview = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfAudiencePreviewDto>(
    { url: `/v1/communications/${id}/audience-preview`, method: 'GET', signal },
    options,
  )
}

export const getGetCommunicationAudiencePreviewQueryKey = (id: string) => {
  return [`/v1/communications/${id}/audience-preview`] as const
}

export const getGetCommunicationAudiencePreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommunicationAudiencePreview>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationAudiencePreview>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCommunicationAudiencePreviewQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommunicationAudiencePreview>>> = ({
    signal,
  }) => getCommunicationAudiencePreview(id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCommunicationAudiencePreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommunicationAudiencePreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommunicationAudiencePreview>>
>
export type GetCommunicationAudiencePreviewQueryError = unknown

export function useGetCommunicationAudiencePreview<
  TData = Awaited<ReturnType<typeof getCommunicationAudiencePreview>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationAudiencePreview>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationAudiencePreview>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationAudiencePreview>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationAudiencePreview<
  TData = Awaited<ReturnType<typeof getCommunicationAudiencePreview>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationAudiencePreview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunicationAudiencePreview>>,
          TError,
          Awaited<ReturnType<typeof getCommunicationAudiencePreview>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommunicationAudiencePreview<
  TData = Awaited<ReturnType<typeof getCommunicationAudiencePreview>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationAudiencePreview>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCommunicationAudiencePreview<
  TData = Awaited<ReturnType<typeof getCommunicationAudiencePreview>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunicationAudiencePreview>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCommunicationAudiencePreviewQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Conta a audiência de uma seleção ainda não salva (MANAGER/ADMIN)
 */
export const previewAudienceCount = (
  audienceSelectionDto: AudienceSelectionDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfAudienceCountDto>(
    {
      url: `/v1/communications/audience/preview`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: audienceSelectionDto,
      signal,
    },
    options,
  )
}

export const getPreviewAudienceCountMutationKey = () => ['previewAudienceCount'] as const

export const getPreviewAudienceCountMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAudienceCount>>,
    TError,
    PreviewAudienceCountMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewAudienceCount>>,
  TError,
  PreviewAudienceCountMutationVariables,
  TContext
> => {
  const mutationKey = getPreviewAudienceCountMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewAudienceCount>>,
    PreviewAudienceCountMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return previewAudienceCount(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PreviewAudienceCountMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewAudienceCount>>
>
export type PreviewAudienceCountMutationBody = AudienceSelectionDto
export type PreviewAudienceCountMutationError = unknown
export type PreviewAudienceCountMutationVariables = { data: AudienceSelectionDto }

/**
 * @summary Conta a audiência de uma seleção ainda não salva (MANAGER/ADMIN)
 */
export const usePreviewAudienceCount = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewAudienceCount>>,
      TError,
      PreviewAudienceCountMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof previewAudienceCount>>,
  TError,
  PreviewAudienceCountMutationVariables,
  TContext
> => {
  return useMutation(getPreviewAudienceCountMutationOptions(options), queryClient)
}
export const getAudienceUsers = (
  params?: GetAudienceUsersParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataPaginationEnvelopeOfAudienceUserDto>(
    { url: `/v1/communications/audience/users`, method: 'GET', params, signal },
    options,
  )
}

export const getGetAudienceUsersQueryKey = (params?: GetAudienceUsersParams) => {
  return [`/v1/communications/audience/users`, ...(params ? [params] : [])] as const
}

export const getGetAudienceUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAudienceUsers>>,
  TError = unknown,
>(
  params?: GetAudienceUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudienceUsers>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAudienceUsersQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAudienceUsers>>> = ({ signal }) =>
    getAudienceUsers(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAudienceUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAudienceUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAudienceUsers>>>
export type GetAudienceUsersQueryError = unknown

export function useGetAudienceUsers<
  TData = Awaited<ReturnType<typeof getAudienceUsers>>,
  TError = unknown,
>(
  params: undefined | GetAudienceUsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudienceUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAudienceUsers>>,
          TError,
          Awaited<ReturnType<typeof getAudienceUsers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAudienceUsers<
  TData = Awaited<ReturnType<typeof getAudienceUsers>>,
  TError = unknown,
>(
  params?: GetAudienceUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudienceUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAudienceUsers>>,
          TError,
          Awaited<ReturnType<typeof getAudienceUsers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAudienceUsers<
  TData = Awaited<ReturnType<typeof getAudienceUsers>>,
  TError = unknown,
>(
  params?: GetAudienceUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudienceUsers>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAudienceUsers<
  TData = Awaited<ReturnType<typeof getAudienceUsers>>,
  TError = unknown,
>(
  params?: GetAudienceUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudienceUsers>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAudienceUsersQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Lista publicações no período planejado e rascunhos sem data
 */
export const getEditorialCommunications = (
  params: GetEditorialCommunicationsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataPaginationEnvelopeOfCommunicationDto>(
    { url: `/v1/communications/editorial`, method: 'GET', params, signal },
    options,
  )
}

export const getGetEditorialCommunicationsQueryKey = (
  params?: GetEditorialCommunicationsParams,
) => {
  return [`/v1/communications/editorial`, ...(params ? [params] : [])] as const
}

export const getGetEditorialCommunicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEditorialCommunications>>,
  TError = unknown,
>(
  params: GetEditorialCommunicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEditorialCommunications>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEditorialCommunicationsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEditorialCommunications>>> = ({
    signal,
  }) => getEditorialCommunications(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEditorialCommunications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEditorialCommunicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEditorialCommunications>>
>
export type GetEditorialCommunicationsQueryError = unknown

export function useGetEditorialCommunications<
  TData = Awaited<ReturnType<typeof getEditorialCommunications>>,
  TError = unknown,
>(
  params: GetEditorialCommunicationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEditorialCommunications>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditorialCommunications>>,
          TError,
          Awaited<ReturnType<typeof getEditorialCommunications>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditorialCommunications<
  TData = Awaited<ReturnType<typeof getEditorialCommunications>>,
  TError = unknown,
>(
  params: GetEditorialCommunicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEditorialCommunications>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEditorialCommunications>>,
          TError,
          Awaited<ReturnType<typeof getEditorialCommunications>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEditorialCommunications<
  TData = Awaited<ReturnType<typeof getEditorialCommunications>>,
  TError = unknown,
>(
  params: GetEditorialCommunicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEditorialCommunications>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista publicações no período planejado e rascunhos sem data
 */

export function useGetEditorialCommunications<
  TData = Awaited<ReturnType<typeof getEditorialCommunications>>,
  TError = unknown,
>(
  params: GetEditorialCommunicationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEditorialCommunications>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEditorialCommunicationsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
